<template>
  <div class="grid grid-cols-2 gap-3">
    <div
      v-for="option in options"
      :key="option.value"
      class="signature-type-card transition-all duration-300 cursor-pointer select-none"
      :style="isSelected(option.value) ? selectedStyle : unselectedStyle"
      @click="toggle(option.value)"
    >
      <div class="flex flex-col items-center text-center w-full">
        <div class="flex items-center justify-center mb-2" style="width: 48px; height: 48px;">
          <img :src="option.icon" :alt="option.title" style="max-width: 100%; max-height: 100%;">
        </div>
        <h4 style="font-size: 0.85rem; font-weight: 700; margin-bottom: 2px; color: #1a202c; line-height: 1.2;">{{ option.title }}</h4>
        <p style="font-size: 0.75rem; color: #718096; margin-bottom: 8px;">{{ option.subtitle }}</p>
        <div @click.stop class="flex justify-center">
          <vs-checkbox :value="isSelected(option.value)" @change="toggle(option.value)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Tarjetas para elegir métodos de firma (IDENTITY, SIMPLE, EFIRMA, FIREL), con el mismo diseño que
// las de crear documento (documents-create-beta/SignerCard.vue). Se usa con v-model sobre un arreglo.
export default {
  name: "SignatureMethodCards",
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      options: [
        { value: 'IDENTITY', title: 'Con identidad', subtitle: '(requiere INE)', icon: require('@/assets/images/document/id.svg') },
        { value: 'SIMPLE', title: 'Firma simple', subtitle: '(extranjeros)', icon: require('@/assets/images/document/sign.svg') },
        { value: 'EFIRMA', title: 'e.firma', subtitle: '(SAT)', icon: require('@/assets/images/document/sat.svg') },
        { value: 'FIREL', title: 'FIREL', subtitle: '(PJF)', icon: require('@/assets/images/document/firel.svg') }
      ],
      selectedStyle: 'border: 2px solid #7c3aed; background-color: #f3f0ff; border-radius: 12px; padding: 12px;',
      unselectedStyle: 'border: 2px solid #e0e0e0; background-color: #ffffff; border-radius: 12px; padding: 12px;'
    }
  },
  methods: {
    isSelected(method) {
      return this.value.includes(method);
    },
    toggle(method) {
      this.$emit('input', this.isSelected(method)
        ? this.value.filter(selected => selected !== method)
        : [...this.value, method]);
    }
  }
}
</script>
